<template lang="pug">
  .photo-reports(v-if="photoReports")
    .photo-reports__border.photo-reports__border--top
    .photo-reports__border.photo-reports__border--right
    .photo-reports__border.photo-reports__border--bottom
    .photo-reports__border.photo-reports__border--left
    .photo-reports__corner.photo-reports__corner--tl
    .photo-reports__corner.photo-reports__corner--tr
    .photo-reports__corner.photo-reports__corner--bl
    .photo-reports__corner.photo-reports__corner--br
    .photo-reports__decor-top
    .photo-reports__decor-bottom
    .photo-reports__title(v-if="h1") {{h1}}
    .photo-reports__content
      .photo-reports__items(v-if="photoReportsItems && photoReportsItems.items")
        router-link.photo-reports__item(v-for="item in photoReportsItems.items", :key="item.id", :to="item.link")
          .photo-reports__item-img-wr(:data-src="item.img")
            .photo-reports__item-img-overlay
              SvgIcon(name="search" width="32" height="32" class="photo-reports__item-img-overlay-ico")
              .photo-reports__item-img-overlay-text Смотреть
            img.photo-reports__item-img.photo-reports__item-img--hide(:src="item.img")
          .photo-reports__item-title(v-if="item.title") {{item.title}}
          .photo-reports__item-date(v-if="item.date") {{item.date}}
      button.photo-reports__items-more(v-if="moreAlbums", @click="loadMoreAlbums")
        SvgIcon(name="recycle" width="25" height="25" class="photo-reports__items-more-loader")
        SvgIcon(name="arrow-down" width="12" height="7" class="photo-reports__items-more-ico")
        .photo-reports__items-more-text Еще...
    .photo-reports__album
      .photo-reports__border.photo-reports__border--right
      .photo-reports__album-preloader
        .photo-reports__border.photo-reports__border--right
        .photo-reports__album-preloader-img
          .photo-reports__album-preloader-img-color-wr
            .photo-reports__album-preloader-img-color
      .photo-reports__album-decor-top
      .photo-reports__album-decor-bottom
      .photo-reports__album-title(v-if="h1") {{h1}}
      button.photo-reports__album-back(v-if="albumItems && albumItems.backText", @click="goBack")
        SvgIcon(name="back" width="7" height="12" class="photo-reports__album-back-ico")
        | {{albumItems.backText}}
      .photo-reports__album-content
        .photo-reports__items(v-if="albumItems && albumItems.items")
          a.photo-reports__item(v-for="item in albumItems.items", :key="item.id", :href="item.link", data-fancybox="gallery")
            .photo-reports__item-img-wr(:data-src="item.img")
              .photo-reports__item-img-overlay
                SvgIcon(name="search" width="32" height="32" class="photo-reports__item-img-overlay-ico")
                .photo-reports__item-img-overlay-text Смотреть
              img.photo-reports__item-img.photo-reports__item-img--hide(:src="item.img")
        button.photo-reports__items-more(v-if="moreItems", @click="loadMoreItems")
          SvgIcon(name="recycle" width="25" height="25" class="photo-reports__items-more-loader")
          SvgIcon(name="arrow-down" width="12" height="7" class="photo-reports__items-more-ico")
          .photo-reports__items-more-text Еще...

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/photoReports/photoReports.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  name: 'PhotoReports',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      photoReports: null,
      photoReportsItems: null,
      albumItems: null,
      isBack: false,
      backLink: '',
      albumsCount: 0,
      itemsCount: 0,
      albumsPerPage: 0,
      itemsPerPage: 0,
      moreAlbums: false,
      moreItems: false,
      ps: null,
      ps2: null
    }
  },

  components: {
    SvgIcon
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadPhotoReportsPage', params => {
      this.request(params.url);
    });

    EventBus.$on('loadPhotoReportsPageInside', params => {
      this.requestInside(params);
    });
  },

  methods: {
    request(url) {
      let params = this.$route.params;

      this.req('PhotoReportsPage:getPhotoReportsPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.photoReports = res.content;
        }

        this.requestInside({params: params, url: this.$route.path});
      }, 'photo-reports');
    },

    requestInside(params) {
      this.albumsCount = 0;
      let count = this.albumsCount;
      let albumId = params.params.albumId || '';
      let url = params.url || '';


      if(!this.photoReports) {
        this.request('/fotootchety');
      }
      else {

        if(albumId.length && url !== '/fotootchety') {
          this.requestAlbumItems(albumId);
        }
        else {
          if(!this.isBack) {
            this.backLink = url;

            this.$nextTick(() => {
              $('.photo-reports__album').removeClass('photo-reports__album--show');
            });

            this.req('PhotoReportsPage:getPhotoReportsAlbums', {count}, res => {
              if(this.checkProperty(res.content)) {
                this.photoReportsItems = res.content;
                this.albumsPerPage = this.photoReportsItems.items.length;
                this.moreAlbums = res.content.more;
              }

              this.$nextTick(() => {
                this.imgPreloader('photo-reports__item-img-wr', 'photo-reports__item-img', '', 250);
                this.initScroll();
              });
            }, '', 'localPageRequest');
          }
          else {
            this.isBack = false;
          }
        }

      }
    },

    requestAlbumItems(albumId) {
      if(!this.photoReportsItems) {
        this.requestInside({params: {}});
      }

      this.$nextTick(() => {
        $('.photo-reports__album').addClass('photo-reports__album--show');
        this.preloader('show');
      });

      this.req('PhotoReportsPage:getPhotoReportsAlbumItems', {albumId}, res => {
        if(this.checkProperty(res.content)) {
          this.albumItems = res.content;
          this.itemsPerPage = this.albumItems.items.length;
          this.moreItems = res.content.more;

          this.$nextTick(() => {
            this.imgPreloader('photo-reports__item-img-wr', 'photo-reports__item-img', '', 250);
            this.initScroll2();
            this.initFancy();
            this.preloader('hide');
          });
        }
      }, '', 'localPageRequest');
    },

    preloader(action) {
      let $preloader = $('.photo-reports__album-preloader');

      if(action === 'show') {
        $preloader.removeClass('photo-reports__album-preloader--hide')
            .addClass('photo-reports__album-preloader--animation');
      }

      if(action === 'hide') {
        $preloader.addClass('photo-reports__album-preloader--hide');

        setTimeout(() => {
          $preloader.removeClass('photo-reports__album-preloader--animation');
        }, 500);
      }
    },

    goBack() {
      this.isBack = true;

      if(this.backLink) {
        this.$router.push({path: this.backLink});
      } else {
        var path = '/fotootchety';

        this.$router.push({path: path});
      }

      this.$nextTick(() => {
        $('.photo-reports__album').removeClass('photo-reports__album--show');
      });
    },

    initFancy() {
      $('.photo-reports__album').find('.photo-reports__item').fancybox({
        image: {
          preload: true,
        },
        clickContent: function(current, event) {
          return current.type === "image" ? "zoom" : false;
        },
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        buttons: ['close'],
        infobar: false,
        hash: false
      });
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.photo-reports__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        const container = document.querySelector('.photo-reports__content');
        container.scrollTop = 0;
        this.ps.update();
      }
    },

    initScroll2() {
      if(this.ps2 === null) {
        this.ps2 = new PerfectScrollbar('.photo-reports__album-content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        const container = document.querySelector('.photo-reports__album-content');
        container.scrollTop = 0;
        this.ps2.update();
      }
    },

    loadMoreAlbums() {
      this.albumsCount = this.albumsCount + this.albumsPerPage;
      let count = this.albumsCount;

      $('.photo-reports__items-more').addClass('photo-reports__items-more--loading');

      this.req('PhotoReportsPage:getPhotoReportsAlbums', {count}, res => {
        if(this.checkProperty(res.content)) {
          this.photoReportsItems.items = this.photoReportsItems.items.concat(res.content.items);
          this.moreAlbums = res.content.more;
        }

        this.$nextTick(() => {
          this.imgPreloader('photo-reports__item-img-wr', 'photo-reports__item-img', '', 250);
          this.ps.update();

          setTimeout(() => {
            $('.photo-reports__items-more').removeClass('photo-reports__items-more--loading');
          }, 500);
        });
      }, '', 'localPageRequest');
    },

    loadMoreItems() {
      this.itemsCount = this.itemsCount + this.itemsPerPage;
      let count = this.itemsCount;
      let albumId = this.$route.params.albumId;

      $('.photo-reports__items-more').addClass('photo-reports__items-more--loading');

      this.req('PhotoReportsPage:getPhotoReportsAlbumItems', {albumId, count}, res => {
        if(this.checkProperty(res.content)) {
          this.albumItems.items = this.albumItems.items.concat(res.content.items);
          this.moreItems = res.content.more;
        }

        this.$nextTick(() => {
          this.imgPreloader('photo-reports__item-img-wr', 'photo-reports__item-img', '', 250);
          this.ps2.update();
          this.initFancy();

          setTimeout(() => {
            $('.photo-reports__items-more').removeClass('photo-reports__items-more--loading');
          }, 500);
        });
      }, '', 'localPageRequest');
    }

    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
